module.exports = __webpack_public_path__ + "static/media/02@2x.de41fbce.jpg";